<template>
    <div class="table-responsive">
        <vs-table stripe :data="master">
            <template slot="thead" class="thead-dark">
              <th>Periodo</th>
              <th>Fecha de pago</th>
              <th>Pago</th>
              <th>Pago efectivo</th>
              <th>Saldo inicial</th>
              <th>Amortización</th>
              <th>Abono Capital</th>
              <th>Intereses</th>
              <th>IVA</th>
              <th>Comisión</th>
              <th>Saldo final</th>
              <th></th>
            </template>
            <template slot-scope="{data}">
                <vs-tr v-for="(m, number) in master">
                    <vs-td>{{number + 1}}</vs-td>
                    <vs-td>{{m.payment_date | human_date}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.payment)}}</vs-td>
                    <vs-td class="table-number bold" style="color:red">${{formatPrice(m.cash_payment)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.initial_debt)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.amortization)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.capital_payment)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.interest)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.tax)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.client_comission)}}</vs-td>
                    <vs-td class="table-number">${{formatPrice(m.final_debt)}}</vs-td>
                    <vs-td v-if="m.paid === 1" style="text-align:center;">
                      <em class="material-icons" style="color:green">check_circle</em>
                    </vs-td>
                    <vs-td v-else-if="m.with_due" style="text-align:center;"><em class="material-icons">attach_money</em></vs-td>
                    <vs-td v-else style="text-align:center;">
                        <em v-if="user.user_id == 1864 || user.user_id == 11838 && !loading" class="material-icons" style="cursor:pointer;" @click="due(m,number)">add_circle</em>
                    </vs-td>
                </vs-tr>
                <vs-tr class="table-active">
                    <vs-td></vs-td>
                    <vs-td class="table-number bold">Total</vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.payment)}}</vs-td>
                    <vs-td class="table-number bold"></vs-td>
                    <vs-td class="table-number bold"></vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.amortization)}}</vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.capital_payment)}}</vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.interest)}}</vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.tax)}}</vs-td>
                    <vs-td class="table-number bold">${{formatPrice(total.client_comission)}}</vs-td>
                    <vs-td class="table-number bold"></vs-td>
                    <vs-td></vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>

<script>
    import {formatPrice, formatMoney} from '../../../../components/admin/filters.js';
    import * as moment from 'moment'
    export default {
        name: "MasterAmortization",
        props: ['project_id'],
        async mounted(){
            await this.getMaster()
        },
        data(){
            return {
                master: [],
                loading: false,
                total:{}
            }
        },
        filters: {
            human_date(date) {
                return moment(date).lang("es").format("D MMM YYYY");
            }

        },
        methods:{
            formatPrice,
            async getMaster(){
                this.loading = true
                this.master = []
                const { data } = await axios.get('/api/cobranza/proyectos/' + this.project_id + '/master')
                this.master = data.master
                this.total = data.total
                this.loading = false
            },
            due(m){
                var fa =  prompt('Generar adeudo de $' + this.formatPrice(m.payment, 2) + ' correspondiente al mes con fecha de pago ' + m.payment_date + '.\nConfirma con tu segundo factor de autenticación:', '');
                if(fa !=  null && fa != ''){
                    this.loading = true;
                    this.showLoading(true);
                    axios.post('/api/cobranza/master/adeudo', {
                        project_id: this.project_id,
                        payment_date: m.payment_date,
                        code: fa
                    }).then(response => {
                        this.showLoading(false);
                        this.$emit('updated', 1)
                        //this.getMaster()
                    }).catch(error => {
                        this.loading = false;
                        this.showLoading(false);
                        if(error.response.data.message != undefined){
                            this.errorNotif("Aviso", error.response.data.message, 4000);
                        }else{
                            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                        }
                    });
                }

            }
        }
    }
</script>

<style scoped>
    i{
        font-size:20px;
    }

    .btn i.material-icons{
        font-size:20px !important;
    }

    .dashboard-loader {
        border: 5px solid #f3f3f3;
        border-radius: 50%;
        border-top: 5px solid #448aff;
        border-bottom: 5px solid #448aff;
        width: 30px;
        height: 30px;
        -webkit-animation: spin 1s linear infinite;
        animation: spin 1s linear infinite;
    }

    td, th
    {
        text-align: center;
        vertical-align: middle;
    }

    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>
